import React from 'react';
import { Box, Grid, Stack, Typography, alpha } from '@mui/material';
import Iconify from '../../iconify';


const RefrigeratedOrderStatus = () => {

    return ( 
        <Box sx={{
            color:"#4B7BE5",
        }}>
            <Grid container alignItems='center' spacing={1} justifyContent='center'>
                <Grid item>
                    <Box sx={{width:20, height:20,  ml:1}}>
                        <Stack alignItems='center' justifyContent='center' sx={{height:1}}>
                            <Iconify icon="material-symbols:ac-unit-rounded" width={20} />
                        </Stack>
                    </Box>
                </Grid>
                <Grid item>
                    <Typography variant='body2' >Este pedido contiene productos refrigerados</Typography>
                </Grid>
            </Grid>
        </Box>
     );
}
 
export default RefrigeratedOrderStatus;